import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Api from 'services/api';

interface ModalBoletoProps {
  showModal: boolean;
  id_income: number;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  parcela: number;
}

const ModalBoleto = (props: ModalBoletoProps) => {
  const { showModal, setShowModal, id_income, parcela } = props;

  return (
    <Modal show={showModal}>
      <div className="row">
        <div className="col-md-12">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title font-weight-bold">
                Deseja gerar boleto da parcela {parcela}?
              </h5>
            </div>
            <div className="modal-body mt-3 text-right">
              <div className="row">
                <div className="col-md-12">
                  <button
                    type="button"
                    className="btn btn-secondary mr-2"
                    onClick={() => setShowModal(false)}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() =>
                      Api.get(`/boletim_web/minha_conta/boletos_new/${id_income}`, {}).then(
                        (response) => {
                          if (response?.data?.url) {
                            window.location.href = response?.data?.url;
                          }
                        },
                      )
                    }
                  >
                    Gerar boleto
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalBoleto;
